// ========================================
// COMPONENTE - FIRMA EXITOSA
// ========================================

interface SignatureSuccessViewProps {
    result?: {
        estado?: 'firmado' | 'parcialmente_firmado';
        firmasCompletadas?: number;
        firmasRequeridas?: number;
    };
}

const SignatureSuccessView = ({ result }: SignatureSuccessViewProps) => {
    // Determinar si el contrato está completamente firmado o parcialmente
    const isCompletelySignature = result?.estado === 'firmado';
    const isParciallySignature = result?.estado === 'parcialmente_firmado';
    const firmasPendientes = (result?.firmasRequeridas || 1) - (result?.firmasCompletadas || 1);

    return (
        <div className="min-h-screen bg-gray-50 p-3 sm:p-4">
        <div className="max-w-md mx-auto mt-20">
        <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 w-full text-center">
            <div className="flex justify-center mb-4">
            <div className={`w-16 h-16 sm:w-20 sm:h-20 rounded-full flex items-center justify-center ${
                isCompletelySignature ? 'bg-green-100' : 'bg-blue-100'
            }`}>
                <svg className={`w-10 h-10 sm:w-12 sm:h-12 ${
                    isCompletelySignature ? 'text-green-600' : 'text-blue-600'
                }`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
            </div>
            </div>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2">
            {isCompletelySignature ? '¡Documento Firmado!' : '¡Firma Registrada!'}
            </h2>
            <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6">
            {isCompletelySignature 
                ? 'Su firma ha sido procesada exitosamente y el contrato está completo.'
                : 'Su firma ha sido registrada correctamente.'
            }
            </p>
            <div className={`border rounded-lg p-4 mb-6 ${
                isCompletelySignature 
                    ? 'bg-green-50 border-green-200' 
                    : 'bg-blue-50 border-blue-200'
            }`}>
            {isCompletelySignature ? (
                <p className="text-xs sm:text-sm text-green-800">
                    ✅ Recibirá una copia del documento firmado completo en su correo electrónico.
                </p>
            ) : (
                <div className="text-xs sm:text-sm text-blue-800 space-y-2">
                    <p className="font-semibold">
                        ℹ️ Este contrato requiere {result?.firmasRequeridas || 1} firmas.
                    </p>
                    <p>
                        🖊️ Firmas completadas: {result?.firmasCompletadas || 1} de {result?.firmasRequeridas || 1}
                    </p>
                    <p>
                        ⏳ Quedan {firmasPendientes} firma(s) pendiente(s).
                    </p>
                    <p className="mt-3">
                        Recibirá el documento final una vez que se completen todas las firmas necesarias.
                    </p>
                </div>
            )}
            </div>
            <button
            onClick={() => window.close()}
            className="w-full sm:w-auto bg-gray-600 text-white px-4 sm:px-6 py-2 text-sm sm:text-base rounded-lg hover:bg-gray-700 transition"
            >
            Cerrar Ventana
            </button>
        </div>
        </div>
        </div>
    );
};

export default SignatureSuccessView;
